import React from 'react'
import { Link } from 'react-router-dom'

function Event({date, title, text, prenote, button}) {
    return (
        <div className="event">
            <div className="event-date">
                <h5 className="event-date-day">{date.day}</h5>
                <div className="event-date-number">{date.num}</div>
                <div>{date.month}</div>
            </div>
            <div className="event-text">
                <h5>{title}</h5>
                <p style={{fontSize:"small"}}>{text}</p>
            </div>
            <div className="event-prenote">
                <div className="event-people">{prenote.used}/{prenote.max}</div>
                {
                    !button && (prenote.isFull ? <button className="button-prenote-full title">FINITI</button> : <button className="button-prenote title"><Link to="/contattaci" onClick={()=>window.scrollTo(0,0)}>PRENOTA</Link></button>)
                }
            </div>
        </div>
    )
}

export default Event
